import * as Yup from 'yup';

const personTagSchema = Yup.object({
  Type: Yup.string().nullable().required('Tag Type is required'),
});

export default personTagSchema;
